import React from "react";
import { useSelector } from "react-redux";
import "./index.css";
import PhoneTemplate from "./templates/PhoneTemplate";
import OtpTemplate from "./templates/OtpTemplate";
import { useSendOtpMutation } from "../../hooks/user-mutation.hook";

function AuthComponent() {
  const user = useSelector((state) => state.user);
  const { mutate: sendOtpToUser, status } = useSendOtpMutation(user);

  if (status === "success" && user.details.phoneNumber) return <OtpTemplate />;
  return <PhoneTemplate otpStatus={status} sendOtpToUser={sendOtpToUser} />;
}

export default AuthComponent;
